"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.585 5L9.711 16.1l-5.297-5.408L3 12.137l5.297 5.407-.013.012L9.699 19l.012-.013.013.013 1.416-1.444-.013-.012L22 6.444z",
    fillRule: "evenodd"
  }));
}

var _default = SvgCheckmark;
exports["default"] = _default;